import { PalettesState } from './palettes.types'

export const state: PalettesState = {
  palettes: [],
  palettesLoadingError: null
}
